import { render, staticRenderFns } from "./ClassesCard.vue?vue&type=template&id=33129abd&scoped=true"
import script from "./ClassesCard.vue?vue&type=script&lang=js"
export * from "./ClassesCard.vue?vue&type=script&lang=js"
import style0 from "./ClassesCard.vue?vue&type=style&index=0&id=33129abd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33129abd",
  null
  
)

export default component.exports